import { API_NAME, REDUX_STORE } from '@funnels/constants';
import { ApplicationActionTypes, ApplicationsReducerState, SharedActionTypes } from '@funnels/types';

const initialState: ApplicationsReducerState = {
  data: [],
  error: null,
  loading: 0,
  locked: false,
};

export default function applicationsReducer(
  state: ApplicationsReducerState = initialState,
  action: ApplicationActionTypes | SharedActionTypes
): ApplicationsReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.CLEAR_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION:
      return {
        ...state,
        data: [...state.data, action.application],
        loading: state.loading + 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION_SUCCESS:
      return {
        ...state,
        data: state.data.map((application) =>
          application.clientId === action.clientId ? { ...application, id: action.id } : application
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS:
      return {
        ...state,
        loading: state.loading + 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS_SUCCESS:
      return {
        ...state,
        data: action.applications
          // Sort applications by created date AES
          .sort((a, b) => {
            const aCreateDate = new Date(a.createdAt || 0);
            const bCreateDate = new Date(b.createdAt || 0);
            return aCreateDate > bCreateDate ? 1 : aCreateDate < bCreateDate ? -1 : 0;
          })
          .map((application) => ({ ...application, clientId: application.id })),
        loading: state.loading - 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.SET_APPLICATION_ERROR:
      // TODO: FUNNEL-1606 - use same pattern in employment reducer, setting error message in same action as fail/abort
      return {
        ...state,
        error: {
          name: API_NAME.APPLICATIONS,
          message: action.message,
        },
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION:
      return {
        ...state,
        data: state.data.map((application) =>
          application.clientId === action.application.clientId ? action.application : application
        ),
        loading: state.loading + 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.CREATE_APPLICATION_FAIL:
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.FETCH_APPLICATIONS_FAIL:
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_FAIL:
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.UPDATE_APPLICATION_ABORT:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.APPLICATIONS.ACTION_TYPES.SET_APPLICATION_LOCKED:
      return {
        ...state,
        locked: action.payload,
      };
    default:
      return state;
  }
}
